import {Component, h, Host, Prop, Listen} from '@stencil/core';
import store, { setLoading, setData, setError } from '../../utils/store';
import {SAFE_URL_PATTERN} from "@utils/html-sanitizer";

@Component({
  tag: 'vs-app-root',
  shadow: false,
})
export class AppRoot {
  @Prop() datapath: string;

  @Listen('dataRequest', { target: 'body' })
  handleDataRequest() {
    const requestPath = this.datapath;
    if (requestPath) {
      this.fetchDataWithPath(requestPath);
    }
  }

  async fetchDataWithPath(path: string) {
    const url = `${path}.model.json`;
    if (!this.isValidUrl(url)) {
      return;
    }
    store.dispatch(setLoading(true));
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      const data = await response.json();
      store.dispatch(setData(data));
    } catch (error) {
      store.dispatch(setError('Failed to fetch data'));
    }
  }

  async fetchData() {
    await this.fetchDataWithPath(this.datapath);
  }

  private isValidUrl(url: string): boolean {
    return SAFE_URL_PATTERN.test(url);
  }

  componentDidLoad(){
    this.fetchData();
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
